export const getSearchParams = () => new URLSearchParams(window.location.search)
